module.exports = __webpack_public_path__ + "static/media/appicon.56714257.png";